import { Controller } from "@hotwired/stimulus"

// Auto-opens the onboarding survey as a modal on the dashboard and locks page
// scroll. Closing via the backdrop or Escape submits the "Maybe later" (snooze)
// form, so dismissing the modal is treated as a snooze — consistent with the
// snooze + cap re-show policy.
export default class extends Controller {
  static targets = ["snooze"]

  connect() {
    document.body.classList.add("overflow-hidden")
    this._onKeydown = (e) => { if (e.key === "Escape") this.snooze() }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._onKeydown)
  }

  // Only when the backdrop itself is clicked, not the card inside it.
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.snooze()
  }

  snooze() {
    this.snoozeTarget.requestSubmit()
  }
}
